import { joinCn } from '../util';
import { useVTab } from './hook';
import type { VTabTriggerProps } from './type';

export const VTabTrigger = ({
  children,
  value,
  disabled = false,
  className,
}: React.PropsWithChildren<VTabTriggerProps>) => {
  const { value: innerValue, setValue, twStyle } = useVTab();

  return (
    <div
      aria-checked={value === innerValue}
      aria-disabled={disabled}
      aria-label={`v-tab-trigger-${value}`}
      className={joinCn(twStyle.tabItem, className)}
      role="menuitemradio"
      onClick={() => (!disabled ? setValue(value) : void 0)}
    >
      {children}
    </div>
  );
};

VTabTrigger.displayName = 'VTabTrigger';
